import { render } from "./training-model.vue?vue&type=template&id=1b41d614"
import script from "./training-model.vue?vue&type=script&lang=js"
export * from "./training-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__